import clsx from 'clsx'
import { computed, defineComponent } from 'vue'
import { type JSX } from 'vue/jsx-runtime'

import VIcon from './VIcon'

interface Props {
  tData?: string
  class?: string
  items: string[]
  value: number
  isFull?: boolean
}

export default defineComponent<Props>((props) => {
  // #region Props Getters

  const tData = computed(() => props.tData ?? 'v-stepper')
  const isFull = computed(() => props.isFull ?? false)

  // #endregion

  // #region Getters

  const steps = computed((): JSX.Element[] => {
    return props.items.map((step, index) => {
      const isNotLast = index + 1 !== props.items.length
      return (
        <div
          t-data={`${tData.value}-step`}
          key={`v-stepper-step-${step}`}
          class={clsx('flex items-center space-x-2', { 'flex-1': isFull.value && isNotLast })}
        >
          <VIcon
            t-data={`${tData.value}-step-icon`}
            class={[
              'flex-none text-[24px]',
              props.value >= index ? 'text-success' : 'text-neutral-400'
            ]}
            icon={props.value > index ? 'material-symbols:check-circle' : 'material-symbols:circle-outline'}
          />
          <span class={['hidden text-input-label tablet:inline', props.value > index ? 'text-success' : 'text-neutral-500']}>
            {step}
          </span>
          {isNotLast &&
            <div
              class={clsx(
                'h-1 border-t-2 border-neutral-300',
                props.value <= index ? 'border-dashed' : 'border-solid',
                isFull.value ? 'w-auto flex-1' : 'w-8'
              )}
            />}
        </div>
      )
    })
  })

  // #endregion

  return () => (
    <div class={clsx('flex space-x-2', props.class, { 'w-full': isFull.value })}>
      {steps.value}
    </div>
  )
}, {
  name: 'VStepper',
  props: [
    'tData',
    'class',
    'value',
    'items',
    'isFull'
  ]
})
